var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.125,
    height: 172.028,
    viewBox: "0 0 150.125 172.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-white",
    transform: "translate(273.1 -50.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    transform: "translate(-273.1 50.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(16.34 18.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M360.008,281.982a5.672,5.672,0,0,1,5.874-9.705l55.57,33.631v-6.314l-14.609-8.841a5.672,5.672,0,0,1,5.874-9.705l8.735,5.287v-7.511a8.389,8.389,0,0,0-4.135-7.231l-50.486-29.71a8.391,8.391,0,0,0-8.51,0L307.836,271.59a8.389,8.389,0,0,0-4.135,7.23v20.134l61.813,37.409a5.673,5.673,0,1,1-5.875,9.705L303.7,312.215v6.315l14.711,8.9a5.673,5.673,0,1,1-5.875,9.705l-8.837-5.348v6.728a8.389,8.389,0,0,0,4.135,7.23l50.486,29.709a8.391,8.391,0,0,0,8.51,0l50.486-29.709a8.39,8.39,0,0,0,4.135-7.23V319.166Z",
    transform: "translate(-303.7 -240.722)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M290.643,154.38a8.834,8.834,0,0,1,4.486,1.222l61.058,35.931a8.845,8.845,0,0,1,4.359,7.623v72.155a8.845,8.845,0,0,1-4.359,7.623l-61.058,35.933a8.845,8.845,0,0,1-8.972,0L225.1,278.935a8.844,8.844,0,0,1-4.359-7.623V199.155a8.845,8.845,0,0,1,4.359-7.623L286.157,155.6a8.848,8.848,0,0,1,4.486-1.222m0-5.159a14.023,14.023,0,0,0-7.1,1.934l-61.058,35.932a14,14,0,0,0-6.9,12.07v72.155a14,14,0,0,0,6.9,12.07l61.058,35.931a14.008,14.008,0,0,0,14.2,0L358.8,283.383a14,14,0,0,0,6.9-12.07V199.155a14,14,0,0,0-6.9-12.07l-61.058-35.93a14.009,14.009,0,0,0-7.1-1.936Z",
    transform: "translate(-215.58 -149.22)",
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.237164cbec485880dd13861df56a0e82.svg";
export { ForwardRef as ReactComponent };